import { OrderLine } from "src/app/order/model/order-line";

export class OrderLinePackedVoKey {
    public boxId: string | undefined;
    public sku: string | undefined;
    public line: OrderLine | undefined;
}